import { styled } from '../../../../../../base-components';

export const MenuContainer = styled('div')(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(2),
}));
